import React, { useState } from "react";
import OtpInput from "react-otp-input";
import { Link, useNavigate } from "react-router-dom";
import { ROUTER } from "../router/constants";
import { Box, Button, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";

const Authentication = () => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));
  const navigate = useNavigate()

  const [otp, setOtp] = useState("");
  const [hasError, setHasError] = useState(false);


  const handleOtpChange = (otp) => {
    setOtp(otp);
  };


  const handleCheckOtp = () => {
    const otpDigits = otp.split('');
    const hasEmptyField = otpDigits.length < 6 || otpDigits.some(d => d.trim() === '');
  
    if (hasEmptyField) {
      setHasError(true);
    } else {
      setHasError(false);
      navigate(ROUTER.ENTER);
    }
  };
  


  return (
    <div
      className="container"
      style={{
        padding: "60px 40px",
        backgroundColor: "white",
        borderRadius: "10px",
        boxShadow:
          "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Typography
        variant={isLargeScreen ? "h1" : "h2"}
        align="center"
        color="black"
        fontWeight={700}
        sx={{
          fontWeight: isLargeScreen ? 600 : 700,
          color: "black",
          mb: "48px",
        }}
      >
        احراز هویت
      </Typography>
      <Grid mb={'64px'}>
        <Typography
          color={theme.palette.info.dark}
          variant={isLargeScreen ? 'h5' : 'h6'}
          align="center"
          sx={{
            mb: '20px'
          }}
        >
          کد رزرو خود را در این قسمت وارد کنید
        </Typography>
        <div className="flex justify-center items-center">
          <OtpInput
            value={otp}
            onChange={handleOtpChange}
            numInputs={6}
            renderInput={(props, index) => (
              <input
                {...props}
                type="tel"
                inputMode="numeric"
                style={{
                  width: "40px",
                  height: "40px",
                  margin: "0 0.5rem",
                  fontSize: "16px",
                  borderRadius: "0.5rem",
                  border: hasError && (!otp[index] || otp[index].trim() === '')
                    ? "2px solid red"
                    : "2px solid #6069E7",
                  textAlign: "center",
                }}
              />
            )}
            containerStyle={{
              justifyContent: "center",
              direction: "ltr",
            }}
            shouldAutoFocus
          />

        </div>
      </Grid>
      <Box sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2
      }}>
        <Box sx={{ width: '50%' }}>
          <Button
            fullWidth
            variant="contained"
            onClick={handleCheckOtp}
            sx={{
              height: '48px',
              py: 1.5,
              px: 3,
              borderRadius: 1,
              fontSize: isLargeScreen ? '16px' : '14px',
              '&:hover': {
                transform: 'scale(1.05)',
                boxShadow: 6
              },
              transition: 'all 0.3s'
            }}
          >
            بررسی
          </Button>

        </Box>
        <Box sx={{ width: '50%' }}>
          <Button
            component={Link}
            to={ROUTER.HOME}
            fullWidth
            variant="outlined"
            sx={{
              height: '48px',
              py: 1.5,
              px: 3,
              borderRadius: 1,
              fontSize: isLargeScreen ? '16px' : '14px',
              color: 'primary.main',
              borderColor: 'primary.main',
              '&:hover': {
                transform: 'scale(1.05)',
                boxShadow: 6,
                borderColor: 'primary.main'
              },
              transition: 'all 0.3s'
            }}
          >
            بازگشت
          </Button>
        </Box>
      </Box>
    </div>
  );
};

export default Authentication;
